import React from 'react';
import {Row, Col, DatePicker} from 'antd';
import {systemService} from "../../../../../services";
import InputField from "../../../../input-field";
import SelectField from "../../../../select-field";
import DividerBlock from '../../../../divider-block';
import FieldBlock from "../../../../field-block";
import i18n from "../../../../../i18n";


export default function FourthStep({ stepFields, setFields, getFieldErrors, country }) {
    const firstToUpper = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    function getPassportDivisionsList(divisionCode, setDivisions) {
        systemService.getPassportDivisionsList(divisionCode)
            .then(data => {
                setDivisions(data);
            })
            .catch();
    }

    return (
        <Row>
            <>
                <DividerBlock label={i18n.t('modals.modalEditLegalEntityNew.divider.guarantor')} />
                <Row>
                    <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                        <InputField
                            name="guarantorSecondName"
                            label={i18n.t('modals.modalEditLegalEntityNew.fields.secondName.title')}
                            value={stepFields.guarantorSecondName}
                            setValue={value => setFields({...stepFields, guarantorSecondName: firstToUpper(value)})}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                        <InputField
                            name="guarantorFirstName"
                            label={i18n.t('modals.modalEditLegalEntityNew.fields.firstName.title')}
                            value={stepFields.guarantorFirstName}
                            setValue={value => setFields({...stepFields, guarantorFirstName: firstToUpper(value)})}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                        <InputField
                            name="guarantorPatronymic"
                            label={i18n.t('modals.modalEditLegalEntityNew.fields.patronymic.title')}
                            value={stepFields.guarantorPatronymic}
                            setValue={value => setFields({...stepFields, guarantorPatronymic: firstToUpper(value)})}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                        <InputField
                            name="guarantorPassportSerial"
                            label={i18n.t('modals.modalEditLegalEntity.fields.guarantorPassportSerial.title')}
                            value={stepFields.guarantorPassportSerial}
                            setValue={value => setFields({...stepFields, guarantorPassportSerial: value.replace(/[^0-9]/g, '')})}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                        <InputField
                            name="guarantorPassportNumber"
                            label={i18n.t('modals.modalEditLegalEntityNew.fields.passportNumber.title')}
                            value={stepFields.guarantorPassportNumber}
                            setValue={value => setFields({...stepFields, guarantorPassportNumber: value.replace(/[^0-9]/g, '')})}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                        <FieldBlock name="guarantorPassportDate" title={i18n.t('modals.modalEditLegalEntityNew.fields.passportDate.title')} getErrors={getFieldErrors}>
                            <DatePicker
                                style={{ width: "100%" }}
                                defaultValue={stepFields.guarantorPassportDate}
                                value={stepFields.guarantorPassportDate}
                                format="DD.MM.YYYY"
                                size="large"
                                name="guarantorPassportDate"
                                onChange={value => setFields({...stepFields, guarantorPassportDate:  value})}
                            />
                        </FieldBlock>
                    </Col>
                    { country === 1 ? (
                        <Col lg={24} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                            <SelectField
                                title={i18n.t('modals.modalEditLegalEntityNew.fields.guarantorPassportDivision.placeholder')}
                                name="guarantorPassportDivision"
                                selectedValue={stepFields.guarantorPassportDivision}
                                values={stepFields.guarantorPassportDivisionsList}
                                onChange={(value) => {
                                    setFields({...stepFields, guarantorPassportDivision: value});
                                }}
                                onSearch={(value) => {
                                    if (value.length > 2) {
                                        getPassportDivisionsList(value, (data) => {
                                            setFields({
                                                ...stepFields,
                                                guarantorPassportDivisionsList: data
                                            });
                                        });
                                    }
                                }}
                                getErrors={getFieldErrors}
                                placeholder={i18n.t('modals.modalEditLegalEntityNew.fields.passportDivision.placeholder')}
                                notFoundText={null}
                                showArrow={false}
                                style={{ width: "100%" }}
                            />
                        </Col>
                    ) : (
                        <>
                            <Col lg={12} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                                <InputField
                                    name="guarantorPassportDivision"
                                    label={i18n.t('modals.modalEditLegalEntityNew.fields.guarantorPassportDivision.label')}
                                    value={stepFields.guarantorPassportDivision}
                                    setValue={value => setFields({...stepFields, guarantorPassportDivision: value})}
                                    getFieldErrors={getFieldErrors}
                                />
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                                <InputField
                                    name="guarantorPassportRegistration"
                                    label={i18n.t('modals.modalEditLegalEntityNew.fields.passportDivision.label')}
                                    value={stepFields.guarantorPassportRegistration}
                                    setValue={value => setFields({...stepFields, guarantorPassportRegistration: value})}
                                    getFieldErrors={getFieldErrors}
                                />
                            </Col>
                        </>
                    )
                    }
                    <DividerBlock label={i18n.t('modals.modalEditLegalEntityNew.divider.guarantorRegAddress')} />
                    <Row>
                        <Col lg={24} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                            <InputField name="guarantorRegAddress" label={i18n.t('modals.modalEditLegalEntityNew.fields.address.title')} value={stepFields.guarantorRegAddress} setValue={value => setFields({...stepFields, guarantorRegAddress: value})} getFieldErrors={getFieldErrors} />
                        </Col>
                    </Row>

                    <DividerBlock label={i18n.t('modals.modalEditLegalEntityNew.divider.guarantorFactAddress')}  />
                    <Row>
                        <Col lg={24} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                            <InputField name="guarantorFactAddress" label={i18n.t('modals.modalEditLegalEntityNew.fields.address.title')} value={stepFields.guarantorFactAddress} setValue={value => setFields({...stepFields, guarantorFactAddress: value})} getFieldErrors={getFieldErrors} />
                        </Col>
                    </Row>
                </Row>
            </>
        </Row>
    );
}
